import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { PairMap } from './marketPairSlice';

export interface OrderPrefillValues {
    instrument: PairMap;
    netQtyPosition: number;
    price: number;
}

export interface OrderState {
    disclosure: boolean;
    prefillValues: OrderPrefillValues;
}

export const initialState: OrderState = {
    disclosure: false,
    prefillValues: {} as OrderPrefillValues
};

export const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setOrderModalDisclosure: (state, action: PayloadAction<boolean>) => {
            state.disclosure = action.payload;
        },
        setOrderModalPrefillValues: (state, action: PayloadAction<OrderPrefillValues>) => {
            state.prefillValues = action.payload;
        }
    }
});

export const { setOrderModalDisclosure, setOrderModalPrefillValues } = orderSlice.actions;

export const selectOrderModalOpened = (state: RootState) => state.order.disclosure;
export const selectOrderModalPrefillValues = (state: RootState) => state.order.prefillValues;

export default orderSlice.reducer;
